document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    // Event listener for share icon click (delegated)
    document.addEventListener('click', function (event) {
        // Check if the clicked target is a share icon (now it uses 'zwssgr-share-icon' class)
        if (event.target && event.target.closest('.zwssgr-share-icon')) {
            // console.log('Share icon clicked');
            
            // Get the post ID from the clicked icon's data-id attribute
            const postId = event.target.closest('.zwssgr-share-icon').getAttribute('data-id');
            // console.log('Post ID:', postId); // Check if postId is correct
            
            // Find the corresponding popup using the correct data-widget-id attribute
            const popup = document.querySelector(`.zwssgr-share-popup[data-widget-id="${postId}"]`);
            // console.log(popup);
            
            if (popup) {
                // console.log('Popup found for post ID:', postId);
                
                // Hide all popups first
                document.querySelectorAll('.zwssgr-share-popup').forEach(popup => popup.style.display = "none");
                
                // Show the corresponding popup
                popup.style.display = "block";
            }
        }

        // Close button logic
        if (event.target && event.target.classList.contains('zwssgr-close-btn')) {
            const popup = event.target.closest('.zwssgr-share-popup');
            popup.style.display = "none";
        }

        // Close the popup if the user clicks outside of it
        if (event.target && event.target.classList.contains('zwssgr-share-popup')) {
            event.target.style.display = "none";
        }
    });
    
    // Close the popup when the "Esc" key is pressed
    document.addEventListener('keydown', function (event) {
        if (event.key === "Escape") {
            // Close any open popups
            document.querySelectorAll('.zwssgr-share-popup').forEach(popup => popup.style.display = "none");
        }
    });
    
    // Handle copy button functionality for all popups
    document.querySelectorAll(".zwssgr-copy-button").forEach((button) => {
        button.addEventListener("click", function () {
            const popup = this.closest(".zwssgr-share-popup"); // Find the parent popup
            const copyText = popup.querySelector(".zwssgr-copy-text").innerText.trim(); // Get correct text

            // Create a temporary input field
            const textArea = document.createElement("textarea");
            textArea.value = copyText;
            document.body.appendChild(textArea);

            // Select and copy text
            textArea.select();
            document.execCommand("copy");

            // Remove temporary element
            document.body.removeChild(textArea);

            // Change button text to "Copied!"
            this.innerText = "Copied!";

            // Revert the button text back to "Copy" after 1 second
            setTimeout(() => {
                this.innerText = "Copy";
            }, 1000);
        });
    });
});
